/** @format */
import { HeaderCheckBoxSelectListElement } from './listTableHeader/HeaderCheckBoxSelectList';

const _ = require('underscore');

export const ipStateIdMapInt = {
    FREE: 0,
    USED: 1,
    PLANNED: 2,
    LOCK: 3,
    ARCHIVE: 4,
};

export const ipStateIdMapI18n = {
    FREE: 'pools:state.free',
    USED: 'pools:state.used',
    PLANNED: 'pools:state.reserved',
    LOCK: 'pools:state.lock',
    ARCHIVE: 'pools:state.archive',
};

export class IpStateHelper {
    getStatus = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { value: ipStateIdMapInt.FREE, name: ipStateIdMapI18n.FREE },
            { value: ipStateIdMapInt.USED, name: ipStateIdMapI18n.USED },
            { value: ipStateIdMapInt.PLANNED, name: ipStateIdMapI18n.PLANNED },
            { value: ipStateIdMapInt.LOCK, name: ipStateIdMapI18n.LOCK },
            { value: ipStateIdMapInt.ARCHIVE, name: ipStateIdMapI18n.ARCHIVE },
        ];
    };
}
